import { useMemberGetQuery } from "modules/members/api";
import { Option } from "state/options";

// No `roles`. It was the org's distinct resource_access access levels, and the
// server no longer sends it (PLO-5082): access level is not the model, entitlements
// are, and an account's entitlement names already arrive on the review-account rows
// themselves. Filling it cost a whole-table scan on every page load.
export interface MFSelectableOptions {
  members: Option[];
  departments: Option[];
  job_titles: Option[];
  location_countries: Option[];
}
const useListOptions = (): MFSelectableOptions | undefined => {
  const { data } = useMemberGetQuery<MFSelectableOptions>(
    ["options"],
    "/members/options",
  );

  return data;
};

export const MF_OPTIONS = {
  useListOptions,
};
